<template>
  <v-container fluid class="skill-create">
    <v-row>
      <v-col class="custom-content-container pt-0" cols="12">
        <v-row>
          <v-col md="12">
            <v-card flat class="custom-grey-border remove-border-radius">
              <v-simple-table
                class="inner-simple-table custom-border-top certs-table"
                fixed-header
              >
                <template v-slot:default>
                  <thead
                    style="
                      background-color: rgb(243, 246, 249);
                      color: rgb(36, 50, 109);
                    "
                  >
                    <tr class="custom-border-bottom">
                      <td
                        class="font-size-16 font-weight-700"
                        style="width: 30%"
                      >
                        Leave Category
                      </td>
                      <td
                        class="font-size-16 font-weight-700"
                        style="width: 15%"
                      >
                        Min Leave
                      </td>
                      <td
                        class="font-size-16 font-weight-700"
                        style="width: 15%"
                      >
                        Max Leave
                      </td>
                      <td
                        class="font-size-16 font-weight-700"
                        style="width: 30%"
                      >
                        Allocated Leave
                      </td>
                      <td
                        class="font-size-16 font-weight-700"
                        style="width: 10%"
                      >
                        Days
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="groupLeaves.length > 0">
                      <tr
                        v-for="(row, index) in groupLeaves"
                        :key="row.leave_type_id"
                        :class="{ 'orange_lighten-5': index % 2 === 0 }"
                      >
                        <!-- Leave Category -->
                        <td>
                          <div class="font-size-16 font-weight-600">
                            {{ row.leave_title }}
                          </div>
                        </td>
                        <!-- Min Leave -->
                        <td>
                          <v-avatar
                            size="35"
                            color="blue lighten-4"
                            class="elevation-0"
                            rounded
                          >
                            <span
                              class="font-size-15 font-weight-700 blue--text text--darken-3"
                            >
                              {{ row.min_leave }}
                            </span>
                          </v-avatar>
                        </td>
                        <!-- Max Leave -->
                        <td>
                          <v-avatar
                            size="35"
                            color="orange lighten-4"
                            class="elevation-0"
                            rounded
                          >
                            <span
                              class="font-size-15 font-weight-700 orange--text text--darken-3"
                            >
                              {{ row.max_leave }}
                            </span>
                          </v-avatar>
                        </td>
                        <!-- Allocated Editable -->
                        <td>
                          <v-text-field
                            style="max-width: 100px"
                            dense
                            filled
                            placeholder="Allocated Leave"
                            solo
                            v-model.number="row.allocated_leave"
                            type="text"
                            inputmode="numeric"
                            :aria-valuemin="row.min_leave"
                            :aria-valuemax="row.max_leave"
                            flat
                            color="cyan"
                            class="mt-0 py-0"
                            @keydown="blockInvalidInput"
                            @input="handleAllocationInput(row, $event)"
                          />
                        </td>
                        <!-- Days -->
                        <td>
                          <span
                            ><em class="font-weight-700 font-size-lg"
                              >days</em
                            ></span
                          >
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td :colspan="5" class="text-center">
                          <p
                            class="m-0 row-not-found font-weight-500 font-size-16"
                          >
                            Sorry! No Leaves Found.
                          </p>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import { EngineerEventBus } from "@/core/lib/engineer/engineer.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { ErrorEventBus } from "@/core/lib/message.lib";

export default {
  name: "engineer-leaves",
  mixins: [ValidationMixin, CommonMixin],
  props: {
    pageLoading: {
      type: Boolean,
      default: false,
    },
    updateEngineer: {
      type: Boolean,
      default: false,
    },
    leavesArr: {
      type: Array,
      default: () => [],
    },
    engineer: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      timeoutLimit: 500,
      timeout: null,
      validationDelay: 1200,
      validationTimeouts: {},
      groupLeaves: [],
    };
  },
  computed: {
    isValid() {
      if (this.groupLeaves.length === 0) return true;
      return this.groupLeaves.every((row) => {
        const val = row.allocated_leave;
        return (
          val !== null &&
          val !== undefined &&
          val !== "" &&
          Number(val) >= Number(row.min_leave) &&
          Number(val) <= Number(row.max_leave)
        );
      });
    },
  },
  watch: {
    isValid: {
      immediate: true,
      handler(newVal) {
        this.$emit("validation-change", newVal);
      },
    },
    leavesArr: {
      immediate: true,
      handler() {
        this.initializeLeaves();
      },
    },
    engineer: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.leaves) {
          this.setEngineerLeaves();
        }
      },
    },
  },
  methods: {
    // initializeLeaves() {
    //   const existingLeaves = this.engineer?.leaves || [];
    //   const leavesMap = existingLeaves.reduce((acc, leave) => {
    //     acc[leave.leave] = leave.leave_allowed;
    //     return acc;
    //   }, {});

    //   this.groupLeaves = this.leavesArr.map((leave) => ({
    //     leave_type_id: leave.id,
    //     leave_title: leave.name,
    //     allocated_leave: leavesMap[leave.id] || 0,
    //     min_leave: leave.min_leave,
    //     max_leave: leave.max_leave,
    //   }));
    //   this.emitLeavesUpdate();
    // },
    initializeLeaves() {
      const existingLeaves = this.engineer?.leaves || [];
      const leavesMap = existingLeaves.reduce((acc, leave) => {
        acc[leave.leave] = leave.leave_allowed;
        return acc;
      }, {});

      this.groupLeaves = this.leavesArr.map((leave) => {
        const minLeaveValue = Number(leave.min_leave);
        let allocatedValue =
          leavesMap[leave.id] !== undefined
            ? Number(leavesMap[leave.id])
            : minLeaveValue;
        if (isNaN(allocatedValue) || allocatedValue < minLeaveValue) {
          allocatedValue = minLeaveValue;
        }
        return {
          leave_type_id: leave.id,
          leave_title: leave.name,
          allocated_leave: allocatedValue,
          min_leave: leave.min_leave,
          max_leave: leave.max_leave,
        };
      });
      this.emitLeavesUpdate();
    },
    // setEngineerLeaves() {
    //   if (!this.lodash.isEmpty(this.engineer.leaves)) {
    //     const engineerLeavesMap = this.engineer.leaves.reduce((acc, leave) => {
    //       acc[leave.leave] = leave.leave_allowed;
    //       return acc;
    //     }, {});

    //     this.groupLeaves = this.leavesArr.map((leave) => ({
    //       leave_type_id: leave.id,
    //       leave_title: leave.name,
    //       allocated_leave: engineerLeavesMap[leave.id] || 0,
    //       min_leave: leave.min_leave,
    //       max_leave: leave.max_leave,
    //     }));
    //   } else {
    //     this.initializeLeaves();
    //   }
    //   this.emitLeavesUpdate();
    // },
    setEngineerLeaves() {
      if (!this.lodash.isEmpty(this.engineer.leaves)) {
        const engineerLeavesMap = this.engineer.leaves.reduce((acc, leave) => {
          acc[leave.leave] = leave.leave_allowed;
          return acc;
        }, {});

        this.groupLeaves = this.leavesArr.map((leave) => {
          const minLeaveValue = Number(leave.min_leave);
          let allocatedValue =
            engineerLeavesMap[leave.id] !== undefined
              ? Number(engineerLeavesMap[leave.id])
              : minLeaveValue;
          if (isNaN(allocatedValue) || allocatedValue < minLeaveValue) {
            allocatedValue = minLeaveValue;
          }
          return {
            leave_type_id: leave.id,
            leave_title: leave.name,
            allocated_leave: allocatedValue,
            min_leave: leave.min_leave,
            max_leave: leave.max_leave,
          };
        });
      } else {
        this.initializeLeaves();
      }
      this.emitLeavesUpdate();
    },
    updateLeaves() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.emitLeavesUpdate();
      }, this.timeoutLimit);
    },
    emitLeavesUpdate() {
      const allLeaves = this.leavesArr.map((leaveType) => {
        const existing = this.groupLeaves.find(
          (l) => l.leave_type_id === leaveType.id
        );
        return {
          leave_type_id: leaveType.id,
          leave_title: leaveType.name,
          allocated_leave: existing ? existing.allocated_leave : 0,
          min_leave: existing.min_leave,
          max_leave: existing.max_leave,
        };
      });

      EngineerEventBus.$emit("update:engineer-leaves", allLeaves);
    },
    checkAllocationLimit(row) {
      if (
        row.allocated_leave === "" ||
        row.allocated_leave === null ||
        row.allocated_leave === undefined
      ) {
        ErrorEventBus.$emit(
          "update:error",
          " Please enter allocated leave for " + row.leave_title
        );
        return;
      }

      const value = Number(row.allocated_leave);
      const minLeave = Number(row.min_leave);
      const maxLeave = Number(row.max_leave);

      if (value < minLeave) {
        ErrorEventBus.$emit(
          "update:error",
          `Minimum ${row.min_leave} days is required for ${row.leave_title}`
        );
      } else if (value > maxLeave) {
        ErrorEventBus.$emit(
          "update:error",
          `Maximum ${row.max_leave} days is allowed for ${row.leave_title}`
        );
      }
    },
    scheduleAllocationValidation(row) {
      const timeoutKey = String(row.leave_type_id);
      clearTimeout(this.validationTimeouts[timeoutKey]);
      this.validationTimeouts[timeoutKey] = setTimeout(() => {
        delete this.validationTimeouts[timeoutKey];
        this.checkAllocationLimit(row);
      }, this.validationDelay);
    },
    handleAllocationInput(row, inputValue) {
      const sanitizedValue = String(
        inputValue === null || inputValue === undefined ? "" : inputValue
      ).replace(/\D/g, "");

      row.allocated_leave =
        sanitizedValue === "" ? "" : Number(sanitizedValue);

      this.scheduleAllocationValidation(row);

      if (
        row.allocated_leave === "" ||
        row.allocated_leave === null ||
        row.allocated_leave === undefined
      ) {
        this.updateLeaves();
        return;
      }

      this.updateLeaves();
    },
    blockInvalidInput(e) {
      const allowedKeys = [
        "Backspace",
        "Delete",
        "Tab",
        "ArrowLeft",
        "ArrowRight",
        "Home",
        "End",
      ];

      if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey) return;

      // Only allow numbers
      if (!/^\d$/.test(e.key)) {
        e.preventDefault();
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
    Object.keys(this.validationTimeouts).forEach((timeoutKey) => {
      clearTimeout(this.validationTimeouts[timeoutKey]);
    });
  },
  mounted() {
    this.setEngineerLeaves();
  },
};
</script>

<style scoped>
.certs-table td {
  border-bottom: thin solid rgba(0, 0, 0, 0.06) !important;
}
</style>
